import { media } from '@rst/libs-ts'
import React from 'react'
import styled, { css } from 'styled-components'
import { themedBorderRadius, color, shadow } from '../..'
import {
	Modal2PropsType,
	ShowAnimationsType,
	TemplateDesktopProps,
	TemplateMobileProps,
} from '../type'
import { Footer } from './footer'
import { Header } from './header'

export const Body: React.FC<Modal2PropsType> = ({ children, ...props }) => {
	return (
		<Wrapper
			mobile={props.mobile}
			desktop={props.desktop}
			showAnimation={props.showAnimation}
			className={'awesome-modal-body'}
			minHeight={props.minHeight}
		>
			<Header
				{...props.header}
				close={props.close}
				isMobileFullScreen={props.mobile?.isFullScreen}
			/>
			<Content
				className={'awesome-modal-content'}
				withoutFooter={!props.footer?.content}
			>
				{children}
			</Content>
			{props.footer?.content && <Footer {...props.footer} />}
			{props.footer?.custom && <Footer {...props.footer} />}
		</Wrapper>
	)
}

const Wrapper = styled.div<{
	desktop?: TemplateDesktopProps
	mobile?: TemplateMobileProps
	showAnimation?: ShowAnimationsType
	minHeight?: string
}>`
	background: ${color('gray-01')};
	box-shadow: ${shadow('block')};
	${themedBorderRadius}
	overflow: hidden;
	padding: 0 32px;
	position: relative;
	display: flex;
	flex-flow: column;

	${media.pure.greater(media.size.sm)} {
		${({ desktop }) =>
			desktop?.isLightBox &&
			css`
				border-radius: 0;
				width: 100%;
				flex: 1;
				height: auto;
			`}
	}

	${media.pure.less(media.size.sm)} {
		padding: 16px;
		padding-top: 0px;
		height: ${({ mobile }) => (mobile?.isFullScreen ? 'auto' : '100%')};
		min-height: ${({ mobile }) => (mobile?.isFullScreen ? '100%' : 'none')};
		border-radius: ${({ mobile }) => (mobile?.isFullScreen ? 0 : '5px')};
	}

	${({ showAnimation }) => {
		if (!showAnimation) return ''
		if (showAnimation === 'downToTop')
			return css`
				animation: show-data-picker 0.2s ease;

				@keyframes show-data-picker {
					from {
						transform: translateY(100%);
					}
					to {
						transform: translateY(0);
					}
				}
			`
		return ''
	}}

	${({ minHeight }) =>
		minHeight &&
		css`
			min-height: ${minHeight};

			.awesome-modal-content {
				display: flex;
				flex-direction: column;
			}
		`}
`

const Content = styled.div<{ withoutFooter?: boolean }>`
	flex: 1;
	${({ withoutFooter }) =>
		withoutFooter &&
		css`
			padding-bottom: 40px;
			${media.pure.less(media.size.sm)} {
				padding-bottom: 24px;
			}
		`}
`
